import imageMerchant from "core/assets/images/base/merchant.webp";

const data = {
  Header: {
    title: "Maximize your reach, minimize your cost",
    description: "Enjoy various benefits by becoming a Gojek merchant partner",
    image: imageMerchant,
  },
  More: [
    {
      title: "Food delivery",
      description:
        "Reach more potential customers and get easy delivery services with GoFood.",
      button: "Register",
      link: "https://blba"
    },
    {
      title: "Cashless payment",
      description:
        "An easier and faster payment system, without the hassle of preparing for change.",
      button: "Register",
      link: "https://blba"
    },
    {
      title: "Point of sale",
      description:
        "Manage sales reports easily with an integrated online system",
      button: "Register",
      link: "https://blba"
    },
  ],
};
export default data;
